module.exports = __webpack_public_path__ + "img/Haende_Outline.07d61d7.svg";